(function () {
  "use strict";

  class VaccinationParasiteScheduleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.__vaccinationScheduleInitialized) return;
      this.__vaccinationScheduleInitialized = true;

      var root = this;
      var currentDate = new Date();

      var todayMonth = root.querySelector("[data-vpsb-today-month]");
      var todayDay = root.querySelector("[data-vpsb-today-day]");
      var todayDate = root.querySelector("[data-vpsb-today-date]");

      if (todayMonth) {
        todayMonth.textContent = new Intl.DateTimeFormat(undefined, {
          month: "short"
        }).format(currentDate);
      }

      if (todayDay) {
        todayDay.textContent = String(currentDate.getDate());
      }

      if (todayDate) {
        todayDate.setAttribute(
          "aria-label",
          new Intl.DateTimeFormat(undefined, {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
          }).format(currentDate)
        );
      }

      var species =
        root.dataset.defaultSpecies === "cat"
          ? "cat"
          : "dog";

      var selectors = {
        spDog: '[data-vpsb-species] [data-value="dog"]',
        spCat: '[data-vpsb-species] [data-value="cat"]',
        name: "[data-vpsb-name]",
        dob: "[data-vpsb-dob]",
        ageBadge: "[data-vpsb-age-badge]",
        region: "[data-vpsb-region]",
        c_unknown: "[data-vpsb-unknown]",
        c_social: "[data-vpsb-social]",
        c_outdoor: "[data-vpsb-outdoor]",
        c_water: "[data-vpsb-water]",
        c_tick: "[data-vpsb-tick]",
        c_multi: "[data-vpsb-multi]",
        checks: "[data-vpsb-checks]",
        go: "[data-vpsb-build]",
        out: "[data-vpsb-output]",
        ics: "#ics"
      };

      var el = function (id) {
        return root.querySelector(
          selectors[id] || ("#" + id)
        );
      };

      if (el("region") && root.dataset.defaultRegion) {
        el("region").value = root.dataset.defaultRegion;
      }

      setSpeciesButtons();
      updateAgeBadge();

      // ------------------------------------------------------------------
      // Input events
      // ------------------------------------------------------------------

      ["spDog", "spCat"].forEach(function (id) {
        var button = el(id);

        if (!button) return;

        button.addEventListener("click", function () {
          species =
            this.dataset.value === "cat"
              ? "cat"
              : "dog";

          setSpeciesButtons();
          updateSpeciesLabels();
          updateAgeBadge();
          rebuildExistingPlan();
        });
      });

      if (el("dob")) {
        el("dob").addEventListener("change", function () {
          updateAgeBadge();
          rebuildExistingPlan();
        });
      }

      if (el("name")) {
        el("name").addEventListener("input", function () {
          rebuildExistingPlan();
        });
      }

      if (el("region")) {
        el("region").addEventListener("change", function () {
          rebuildExistingPlan();
        });
      }

      [
        "c_unknown",
        "c_social",
        "c_outdoor",
        "c_water",
        "c_tick",
        "c_multi"
      ].forEach(function (id) {
        var checkbox = el(id);

        if (!checkbox) return;

        checkbox.addEventListener("change", function () {
          rebuildExistingPlan();
        });
      });

      if (el("go")) {
        el("go").addEventListener("click", build);
      }

      function setSpeciesButtons() {
        if (el("spDog")) {
          el("spDog").setAttribute(
            "aria-pressed",
            species === "dog"
              ? "true"
              : "false"
          );
        }

        if (el("spCat")) {
          el("spCat").setAttribute(
            "aria-pressed",
            species === "cat"
              ? "true"
              : "false"
          );
        }
      }

      function updateSpeciesLabels() {
        // Reserved for future species-specific field copy.
      }

      function updateAgeBadge() {
        var badge = el("ageBadge");
        var dobInput = el("dob");

        if (!badge || !dobInput) return;

        var age = ageFrom(dobInput.value);

        if (!age) {
          badge.hidden = true;
          badge.style.display = "none";
          badge.textContent = "";
          return;
        }

        badge.hidden = false;
        badge.style.display = "inline-block";
        badge.textContent =
          age.label +
          " · " +
          age.stage;
      }

      function rebuildExistingPlan() {
        if (!root.__plan) return;
        build();
      }

      // ------------------------------------------------------------------
      // Date helpers
      // ------------------------------------------------------------------

      function parseDate(value) {
        if (!value) return null;

        var parts = value.split("-");

        if (parts.length !== 3) return null;

        var date = new Date(
          Number(parts[0]),
          Number(parts[1]) - 1,
          Number(parts[2])
        );

        return Number.isNaN(date.getTime())
          ? null
          : date;
      }

      function addDays(date, number) {
        var result = new Date(date);
        result.setDate(result.getDate() + number);
        return result;
      }

      function addWeeks(date, number) {
        return addDays(date, number * 7);
      }

      function addMonths(date, number) {
        var result = new Date(date);
        result.setMonth(result.getMonth() + number);
        return result;
      }

      function addYears(date, number) {
        var result = new Date(date);
        result.setFullYear(result.getFullYear() + number);
        return result;
      }

      function today() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }

      function fmt(date) {
        return date.toLocaleDateString(undefined, {
          weekday: "short",
          day: "numeric",
          month: "short",
          year: "numeric"
        });
      }

      function fmtShort(date) {
        return date.toLocaleDateString(undefined, {
          day: "numeric",
          month: "short",
          year: "numeric"
        });
      }

      function daysBetween(start, end) {
        return Math.round(
          (end - start) / 86400000
        );
      }

      function ageFrom(dobString) {
        var dob = parseDate(dobString);

        if (!dob) return null;

        var current = today();

        if (dob > current) return null;

        var days = daysBetween(dob, current);
        var weeks = Math.floor(days / 7);
        var months = Math.floor(days / 30.44);
        var years = days / 365.25;
        var label;

        if (weeks < 16) {
          label =
            weeks +
            " week" +
            (weeks === 1 ? "" : "s") +
            " old";
        } else if (months < 24) {
          label =
            months +
            " month" +
            (months === 1 ? "" : "s") +
            " old";
        } else {
          label =
            (Math.floor(years * 10) / 10) +
            " years old";
        }

        var stage;

        if (species === "dog") {
          if (months < 4) {
            stage = "Puppy (primary series)";
          } else if (months < 12) {
            stage = "Young puppy / adolescent";
          } else if (years < 8) {
            stage = "Adult dog";
          } else {
            stage = "Senior dog";
          }
        } else {
          if (months < 4) {
            stage = "Kitten (primary series)";
          } else if (months < 12) {
            stage = "Young cat / adolescent";
          } else if (years < 10) {
            stage = "Adult cat";
          } else {
            stage = "Senior cat";
          }
        }

        return {
          dob: dob,
          days: days,
          weeks: weeks,
          months: months,
          years: years,
          label: label,
          stage: stage
        };
      }

      // ------------------------------------------------------------------
      // Status helpers
      // ------------------------------------------------------------------

      function statusFor(date) {
        var current = today();
        var difference = daysBetween(current, date);

        if (difference < -14) {
          return {
            cls: "past",
            txt: "Window passed"
          };
        }

        if (difference < 0) {
          return {
            cls: "overdue",
            txt: "Overdue"
          };
        }

        if (difference <= 30) {
          return {
            cls: "soon",
            txt: "Due soon"
          };
        }

        return {
          cls: "upcoming",
          txt: "Upcoming"
        };
      }

      // ------------------------------------------------------------------
      // Build
      // ------------------------------------------------------------------

      function build() {
        var age = ageFrom(
          el("dob")
            ? el("dob").value
            : ""
        );

        var output = el("out");

        if (!output) return;

        if (!age) {
          root.__plan = null;

          output.innerHTML =
            '<div class="empty">' +
              '<div class="big">&#9888;&#65039;</div>' +
              "<h3>Add a date of birth</h3>" +
              "<p>Enter a valid date of birth (not in the future) so the schedule can be dated to your pet.</p>" +
            "</div>";

          return;
        }

        var options = {
          unknown:
            el("c_unknown")
              ? el("c_unknown").checked
              : false,
          social:
            el("c_social")
              ? el("c_social").checked
              : false,
          outdoor:
            el("c_outdoor")
              ? el("c_outdoor").checked
              : false,
          water:
            el("c_water")
              ? el("c_water").checked
              : false,
          tick:
            el("c_tick")
              ? el("c_tick").checked
              : false,
          multi:
            el("c_multi")
              ? el("c_multi").checked
              : false,
          region:
            el("region")
              ? el("region").value
              : "au",
          name:
            (
              el("name") &&
              el("name").value
                ? el("name").value
                : ""
            ).trim()
        };

        var vaccines =
          species === "dog"
            ? dogVaccines(age, options)
            : catVaccines(age, options);

        var parasites =
          species === "dog"
            ? dogParasites(age, options)
            : catParasites(age, options);

        render(
          age,
          options,
          vaccines,
          parasites
        );

        root.__plan = {
          a: age,
          opt: options,
          vax: vaccines,
          para: parasites
        };
      }

      // ------------------------------------------------------------------
      // Dog vaccines
      // ------------------------------------------------------------------

      function dogVaccines(age, options) {
        var dob = age.dob;
        var rows = [];
        var current = today();

        var rabiesRequired =
          options.region === "hk" ||
          options.region === "us" ||
          options.region === "other";

        var rabiesTravel =
          options.region === "au" ||
          options.region === "nz" ||
          options.region === "uk";

        var coreDates = [
          addWeeks(dob, 8),
          addWeeks(dob, 12),
          addWeeks(dob, 16)
        ];

        if (age.weeks < 16 || options.unknown) {
          if (options.unknown && age.weeks >= 16) {
            rows.push(
              makeRow(
                "C3 / DHP — restart dose 1",
                "Distemper, hepatitis (adenovirus), parvovirus",
                "core",
                nextFrom(current, 0)
              )
            );

            rows.push(
              makeRow(
                "C3 / DHP — restart dose 2",
                "Confirms protection when history is unknown",
                "core",
                nextFrom(current, 28)
              )
            );

            rows.push(
              makeRow(
                "C3 / DHP — booster",
                "Then every 3 years",
                "core",
                addYears(current, 1)
              )
            );
          } else {
            coreDates.forEach(function (date, index) {
              rows.push(
                makeRow(
                  "C3 / DHP — dose " + (index + 1),
                  "Distemper, hepatitis (adenovirus), parvovirus",
                  "core",
                  date
                )
              );
            });

            rows.push(
              makeRow(
                "C3 / DHP — 12-month booster",
                "First adult booster; then every 3 years",
                "core",
                addYears(dob, 1)
              )
            );
          }
        } else {
          rows.push(
            makeRow(
              "C3 / DHP — adult booster",
              "Core; typically every 3 years",
              "core",
              nextAnnualOrTri(dob, 3),
              true
            )
          );
        }

        if (rabiesRequired) {
          if (age.weeks < 12 || options.unknown) {
            var rabiesDate =
              age.weeks < 12
                ? addWeeks(dob, 12)
                : nextFrom(current, 0);

            rows.push(
              makeRow(
                "Rabies",
                "Legally required in your region; from 12 weeks",
                "core",
                rabiesDate
              )
            );

            rows.push(
              makeRow(
                "Rabies — booster",
                "12 months later, then per local law (1–3 yrs)",
                "core",
                addYears(rabiesDate, 1)
              )
            );
          } else {
            rows.push(
              makeRow(
                "Rabies — booster",
                "Per local law (every 1–3 years)",
                "core",
                nextAnnualOrTri(dob, 1),
                true
              )
            );
          }
        } else if (rabiesTravel) {
          rows.push(
            makeRow(
              "Rabies",
              "Not routinely required where you live (rabies-free). Only needed for overseas travel/export — check import rules early.",
              "non",
              null,
              false,
              "travel"
            )
          );
        }

        if (options.water || options.outdoor) {
          if (age.weeks < 16 || options.unknown) {
            var leptospirosisDate =
              age.weeks < 12
                ? addWeeks(dob, 12)
                : nextFrom(current, 0);

            rows.push(
              makeRow(
                "Leptospirosis — dose 1",
                "Rats, wildlife, floodwater, farms; from 12 weeks",
                "non",
                leptospirosisDate
              )
            );

            rows.push(
              makeRow(
                "Leptospirosis — dose 2",
                "2–4 weeks after dose 1, then yearly",
                "non",
                addWeeks(leptospirosisDate, 3)
              )
            );
          } else {
            rows.push(
              makeRow(
                "Leptospirosis — annual booster",
                "Yearly where risk is ongoing",
                "non",
                nextAnnualOrTri(dob, 1),
                true
              )
            );
          }
        }

        if (options.social) {
          if (age.weeks < 12) {
            rows.push(
              makeRow(
                "Kennel cough (C5 top-up)",
                "Bordetella + parainfluenza; before boarding/daycare/parks",
                "non",
                addWeeks(dob, 12)
              )
            );
          } else if (options.unknown) {
            rows.push(
              makeRow(
                "Kennel cough (C5)",
                "Give at least 1 week before boarding/daycare/social exposure",
                "non",
                nextFrom(current, 0)
              )
            );
          }

          rows.push(
            makeRow(
              "Kennel cough — booster",
              "Yearly (or 6-monthly for high exposure / boarding requirements)",
              "non",
              nextAnnualOrTri(dob, 1),
              true
            )
          );
        }

        return dedupeSort(rows);
      }

      // ------------------------------------------------------------------
      // Cat vaccines
      // ------------------------------------------------------------------

      function catVaccines(age, options) {
        var dob = age.dob;
        var rows = [];
        var current = today();

        var rabiesRequired =
          options.region === "hk" ||
          options.region === "us" ||
          options.region === "other";

        var rabiesTravel =
          options.region === "au" ||
          options.region === "nz" ||
          options.region === "uk";

        var outdoorRisk =
          options.outdoor ||
          options.multi;

        if (age.weeks < 18 || options.unknown) {
          if (options.unknown && age.weeks >= 18) {
            rows.push(
              makeRow(
                "F3 / FVRCP — restart dose 1",
                "Panleukopenia, herpesvirus, calicivirus",
                "core",
                nextFrom(current, 0)
              )
            );

            rows.push(
              makeRow(
                "F3 / FVRCP — restart dose 2",
                "2–4 weeks after dose 1",
                "core",
                nextFrom(current, 28)
              )
            );

            rows.push(
              makeRow(
                "F3 / FVRCP — booster",
                "Then every 3 years",
                "core",
                addYears(current, 1)
              )
            );
          } else {
            [8, 12, 16].forEach(function (week, index) {
              rows.push(
                makeRow(
                  "F3 / FVRCP — dose " + (index + 1),
                  "Panleukopenia, herpesvirus, calicivirus",
                  "core",
                  addWeeks(dob, week)
                )
              );
            });

            rows.push(
              makeRow(
                "F3 / FVRCP — 12-month booster",
                "First adult booster; then every 3 years",
                "core",
                addYears(dob, 1)
              )
            );
          }
        } else {
          rows.push(
            makeRow(
              "F3 / FVRCP — adult booster",
              "Core; typically every 3 years (annual for high-risk / cattery)",
              "core",
              nextAnnualOrTri(dob, 3),
              true
            )
          );
        }

        if (age.months < 12 && !options.unknown) {
          rows.push(
            makeRow(
              "FeLV — dose 1",
              "Feline leukaemia; recommended for all kittens; from 8 weeks",
              "core",
              addWeeks(
                dob,
                Math.max(8, age.weeks)
              )
            )
          );

          rows.push(
            makeRow(
              "FeLV — dose 2",
              "3–4 weeks after dose 1",
              "core",
              addWeeks(
                dob,
                Math.max(11, age.weeks + 3)
              )
            )
          );

          if (outdoorRisk) {
            rows.push(
              makeRow(
                "FeLV — annual booster",
                "Continue yearly for outdoor / multi-cat exposure",
                "non",
                addYears(dob, 1),
                true
              )
            );
          }
        } else if (outdoorRisk) {
          rows.push(
            makeRow(
              "FeLV",
              "Recommended for cats that go outdoors or live with other cats; test first if history unknown",
              "non",
              nextFrom(current, 0)
            )
          );

          rows.push(
            makeRow(
              "FeLV — annual booster",
              "Yearly while exposure continues",
              "non",
              nextAnnualOrTri(dob, 1),
              true
            )
          );
        }

        if (rabiesRequired) {
          if (age.weeks < 12 || options.unknown) {
            var rabiesDate =
              age.weeks < 12
                ? addWeeks(dob, 12)
                : nextFrom(current, 0);

            rows.push(
              makeRow(
                "Rabies",
                "Legally required in your region; from 12 weeks",
                "core",
                rabiesDate
              )
            );

            rows.push(
              makeRow(
                "Rabies — booster",
                "12 months later, then per local law",
                "core",
                addYears(rabiesDate, 1)
              )
            );
          } else {
            rows.push(
              makeRow(
                "Rabies — booster",
                "Per local law (every 1–3 years)",
                "core",
                nextAnnualOrTri(dob, 1),
                true
              )
            );
          }
        } else if (rabiesTravel) {
          rows.push(
            makeRow(
              "Rabies",
              "Not routinely required where you live (rabies-free). Needed only for overseas travel/export.",
              "non",
              null,
              false,
              "travel"
            )
          );
        }

        return dedupeSort(rows);
      }

      // ------------------------------------------------------------------
      // Parasites
      // ------------------------------------------------------------------

      function dogParasites(age, options) {
        return commonParasites(
          age,
          options,
          "dog"
        );
      }

      function catParasites(age, options) {
        return commonParasites(
          age,
          options,
          "cat"
        );
      }

      function commonParasites(age, options, currentSpecies) {
        var dob = age.dob;
        var current = today();
        var rows = [];

        var heartwormEndemic =
          options.region !== "uk";

        var tickPriority =
          options.tick ||
          options.outdoor ||
          options.region === "au";

        if (age.weeks < 12) {
          rows.push(
            makeRow(
              "Intestinal worming — puppy/kitten phase",
              "Every 2 weeks from 2 weeks until 12 weeks of age (roundworm & hookworm)",
              "para",
              nextWorm(dob, age),
              false,
              "worm"
            )
          );
        } else if (age.months < 6) {
          rows.push(
            makeRow(
              "Intestinal worming — monthly",
              "Monthly until 6 months of age",
              "para",
              nextMonthly(current),
              false,
              "ongoing"
            )
          );
        } else {
          rows.push(
            makeRow(
              "Intestinal worming — every 3 months",
              "Adult maintenance; monthly if hunts/scavenges or young children at home",
              "para",
              nextQuarter(current),
              false,
              "ongoing"
            )
          );
        }

        if (heartwormEndemic) {
          var speciesWord =
            currentSpecies === "dog"
              ? "Dogs"
              : "Cats";

          if (age.weeks < 12) {
            rows.push(
              makeRow(
                "Heartworm prevention — start",
                "Begin by 12 weeks of age, then monthly year-round. " +
                  speciesWord +
                  " started after 6 months of age should be tested first.",
                "para",
                addWeeks(dob, 12)
              )
            );
          } else {
            var note =
              currentSpecies === "dog"
                ? "Mosquito-borne. Blood test first if never on prevention, then monthly year-round (or a yearly injection)."
                : "Mosquito-borne. Monthly year-round — there is no safe treatment once a cat is infected, so prevention is everything.";

            rows.push(
              makeRow(
                "Heartworm prevention — monthly",
                note,
                "para",
                nextMonthly(current),
                false,
                "ongoing"
              )
            );
          }
        }

        rows.push(
          makeRow(
            "Flea prevention — monthly",
            "Year-round in warm/humid climates; treat all pets in the home together.",
            "para",
            nextMonthly(current),
            false,
            "ongoing"
          )
        );

        if (tickPriority) {
          var tickText =
            options.tick
              ? "Paralysis ticks can kill within days. Use a proven tick product year-round and search your pet daily after walks."
              : "Use tick prevention through tick season (and year-round in warm zones).";

          rows.push(
            makeRow(
              "Tick prevention — monthly",
              "<span style='color:#b42318;font-weight:700'>High priority.</span> " +
                tickText,
              "para",
              nextMonthly(current),
              false,
              "ongoing"
            )
          );
        }

        return rows;
      }

      // ------------------------------------------------------------------
      // Row builders and date pickers
      // ------------------------------------------------------------------

      function makeRow(
        name,
        detail,
        kind,
        date,
        ongoing,
        flag
      ) {
        return {
          name: name,
          detail: detail,
          kind: kind,
          date: date,
          ongoing: Boolean(ongoing),
          flag: flag || null
        };
      }

      function nextFrom(current, days) {
        return addDays(current, days);
      }

      function nextMonthly(current) {
        return current;
      }

      function nextQuarter(current) {
        return current;
      }

      function nextWorm(dob, age) {
        var nextWeek =
          age.weeks +
          (age.weeks % 2 === 0 ? 2 : 1);

        if (nextWeek < 2) nextWeek = 2;
        if (nextWeek > 12) nextWeek = 12;

        return addWeeks(dob, nextWeek);
      }

      function nextAnnualOrTri(dob, everyYears) {
        var current = today();
        var date = addYears(
          new Date(dob),
          1
        );

        while (date < current) {
          date = addYears(
            date,
            everyYears
          );
        }

        return date;
      }

      function dedupeSort(rows) {
        rows.sort(function (first, second) {
          if (!first.date && !second.date) return 0;
          if (!first.date) return 1;
          if (!second.date) return -1;
          return first.date - second.date;
        });

        return rows;
      }

      // ------------------------------------------------------------------
      // Render
      // ------------------------------------------------------------------

      function render(
        age,
        options,
        vaccines,
        parasites
      ) {
        var petName =
          options.name ||
          (
            species === "dog"
              ? "Your dog"
              : "Your cat"
          );

        var regionName = {
          au: "Australia",
          nz: "New Zealand",
          hk: "Hong Kong",
          uk: "UK / Ireland",
          us: "US / Canada",
          other: "Other"
        }[options.region];

        var urgent = vaccines.filter(function (row) {
          var difference =
            row.date
              ? daysBetween(today(), row.date)
              : null;

          return (
            row.date &&
            row.kind === "core" &&
            difference < 0 &&
            difference > -365
          );
        });

        var html = "";

        html += '<div class="summary">';
        html +=
          '<div class="s"><span>Pet</span><b>' +
          esc(petName) +
          "</b></div>";
        html +=
          '<div class="s"><span>Species</span><b>' +
          (
            species === "dog"
              ? "Dog"
              : "Cat"
          ) +
          "</b></div>";
        html +=
          '<div class="s"><span>Age</span><b>' +
          age.label +
          "</b></div>";
        html +=
          '<div class="s"><span>Life stage</span><b>' +
          age.stage +
          "</b></div>";
        html +=
          '<div class="s"><span>Region</span><b>' +
          regionName +
          "</b></div>";
        html += "</div>";

        if (urgent.length) {
          html +=
            '<div class="callout warn">' +
              '<div class="ic">&#9888;&#65039;</div>' +
              "<div><b>Catch up soon.</b> " +
                esc(petName) +
                " looks overdue for " +
                urgent.length +
                " core " +
                (
                  urgent.length === 1
                    ? "vaccine"
                    : "vaccines"
                ) +
                ". Core vaccines protect against life-threatening disease (parvo, distemper, panleukopenia). Book with your vet to get back on track &mdash; an unvaccinated pup or kitten is genuinely at risk." +
              "</div>" +
            "</div>";
        }

        if (options.unknown) {
          html +=
            '<div class="callout info">' +
              '<div class="ic">&#8505;&#65039;</div>' +
              "<div><b>Unknown history.</b> With no reliable records, the safest approach is to treat " +
                esc(petName) +
                " as unprotected and start a fresh primary course. Your vet may run a titre test for some diseases instead &mdash; ask." +
              "</div>" +
            "</div>";
        } else if (age.months >= 12) {
          html +=
            '<div class="callout info">' +
              '<div class="ic">&#8505;&#65039;</div>' +
              "<div><b>Booster dates are estimated.</b> For an adult pet, boosters are counted from your pet's birthday here. The real anchor is the date of the <i>last</i> vaccination on record &mdash; shift these dates to match your vet's history if they differ.</div>" +
            "</div>";
        }

        html +=
          '<div class="sec">' +
            '<h3><span class="dot"></span>Vaccination schedule</h3>' +
            '<p class="sh">Core vaccines are recommended for every pet. Non-core are added based on your answers.</p>' +
            vaxTable(vaccines) +
          "</div>";

        html +=
          '<div class="sec">' +
            '<h3><span class="dot" style="background:var(--vpsb-accent)"></span>Parasite prevention plan</h3>' +
            '<p class="sh">Worming, heartworm, fleas and ticks. Many modern products combine several &mdash; ask your vet for the simplest option that covers your pet\'s risks.</p>' +
            paraTable(parasites) +
          "</div>";

        html +=
          '<div class="actions">' +
            '<button type="button" class="btn secondary" id="ics">&#128197; Add reminders to calendar</button>' +
          "</div>";

        html +=
          '<div class="cta">' +
            '<div class="div"></div>' +
            "<h4>Never miss a due date again</h4>" +
            "<p>ASK A VET&#8482; keeps this whole schedule for every pet you own &mdash; vaccines, worming, heartworm, fleas and ticks &mdash; with automatic reminders, medical history and certified vet chat when something's not right. This builder is a snapshot; the app keeps it current.</p>" +
            '<p class="talk">Talk. Track. Trust. &mdash; Ask A Vet.</p>' +
          "</div>";

        el("out").innerHTML = html;

        var icsButton = el("ics");

        if (icsButton) {
          icsButton.addEventListener(
            "click",
            exportICS
          );
        }
      }

      function vaxTable(vaccines) {
        var html =
          "<table>" +
            "<thead>" +
              "<tr>" +
                "<th>Vaccine</th>" +
                "<th>When</th>" +
                "<th>Type</th>" +
                "<th>Status</th>" +
              "</tr>" +
            "</thead>" +
            "<tbody>";

        vaccines.forEach(function (row) {
          var when;
          var status;

          if (!row.date) {
            when =
              '<span class="when">As needed' +
                "<small>" +
                  (
                    row.flag === "travel"
                      ? "Travel only"
                      : ""
                  ) +
                "</small>" +
              "</span>";

            status =
              '<span class="st past">' +
                '<span class="d"></span>' +
                "Optional" +
              "</span>";
          } else if (row.ongoing) {
            when =
              '<span class="when">' +
                fmtShort(row.date) +
                "<small>then ongoing boosters</small>" +
              "</span>";

            var ongoingStatus = statusFor(row.date);

            status =
              '<span class="st ' +
                ongoingStatus.cls +
              '">' +
                '<span class="d"></span>' +
                ongoingStatus.txt +
              "</span>";
          } else {
            when =
              '<span class="when">' +
                fmtShort(row.date) +
                "<small>" +
                  relLabel(row.date) +
                "</small>" +
              "</span>";

            var rowStatus = statusFor(row.date);

            status =
              '<span class="st ' +
                rowStatus.cls +
              '">' +
                '<span class="d"></span>' +
                rowStatus.txt +
              "</span>";
          }

          html +=
            "<tr>" +
              '<td class="vname">' +
                row.name +
                "<small>" +
                  row.detail +
                "</small>" +
              "</td>" +
              "<td>" +
                when +
              "</td>" +
              "<td>" +
                '<span class="tag ' +
                  (
                    row.kind === "core"
                      ? "core"
                      : "non"
                  ) +
                '">' +
                  (
                    row.kind === "core"
                      ? "Core"
                      : "Non-core"
                  ) +
                "</span>" +
              "</td>" +
              "<td>" +
                status +
              "</td>" +
            "</tr>";
        });

        html +=
            "</tbody>" +
          "</table>";

        return html;
      }

      function paraTable(parasites) {
        var html =
          "<table>" +
            "<thead>" +
              "<tr>" +
                "<th>Protection</th>" +
                "<th>When</th>" +
                "<th>Frequency</th>" +
              "</tr>" +
            "</thead>" +
            "<tbody>";

        parasites.forEach(function (row) {
          var when;
          var frequency;

          if (row.flag === "ongoing") {
            when =
              '<span class="when">Start now' +
                "<small>" +
                  relLabel(row.date) +
                "</small>" +
              "</span>";

            frequency =
              '<span class="st ongoing">' +
                '<span class="d"></span>' +
                "Ongoing" +
              "</span>";
          } else if (row.flag === "worm") {
            when =
              '<span class="when">' +
                fmtShort(row.date) +
                "<small>next dose</small>" +
              "</span>";

            frequency =
              '<span class="st soon">' +
                '<span class="d"></span>' +
                "Every 2 weeks" +
              "</span>";
          } else {
            when =
              '<span class="when">' +
                fmtShort(row.date) +
                "<small>" +
                  relLabel(row.date) +
                "</small>" +
              "</span>";

            var status = statusFor(row.date);

            frequency =
              '<span class="st ' +
                status.cls +
              '">' +
                '<span class="d"></span>' +
                status.txt +
              "</span>";
          }

          html +=
            "<tr>" +
              '<td class="vname">' +
                row.name +
                "<small>" +
                  row.detail +
                "</small>" +
              "</td>" +
              "<td>" +
                when +
              "</td>" +
              "<td>" +
                frequency +
              "</td>" +
            "</tr>";
        });

        html +=
            "</tbody>" +
          "</table>";

        return html;
      }

      function relLabel(date) {
        var days = daysBetween(
          today(),
          date
        );

        if (days < -14) return "window passed";
        if (days < 0) return Math.abs(days) + " days ago";
        if (days === 0) return "today";
        if (days <= 31) return "in " + days + " days";
        if (days < 365) return "in ~" + Math.round(days / 30) + " months";

        var years =
          Math.round(
            (days / 365) * 10
          ) / 10;

        return (
          "in ~" +
          years +
          " year" +
          (years === 1 ? "" : "s")
        );
      }

      // ------------------------------------------------------------------
      // ICS export
      // ------------------------------------------------------------------

      function exportICS() {
        var plan = root.__plan;

        if (!plan) return;

        var lines = [
          "BEGIN:VCALENDAR",
          "VERSION:2.0",
          "PRODID:-//ASK A VET//Schedule Builder//EN",
          "CALSCALE:GREGORIAN"
        ];

        var name =
          plan.opt.name ||
          (
            species === "dog"
              ? "Dog"
              : "Cat"
          );

        var events = [];

        plan.vax.forEach(function (row) {
          if (!row.date) return;

          events.push({
            d: row.date,
            t:
              name +
              ": " +
              stripTags(row.name),
            desc: stripTags(row.detail)
          });
        });

        plan.para.forEach(function (row) {
          if (!row.date || row.flag === "ongoing") return;

          events.push({
            d: row.date,
            t:
              name +
              ": " +
              stripTags(row.name),
            desc: stripTags(row.detail)
          });
        });

        plan.para.forEach(function (row) {
          if (row.flag !== "ongoing") return;

          events.push({
            d: row.date,
            t:
              name +
              ": " +
              stripTags(row.name),
            desc:
              "Recurring — set to repeat monthly. " +
              stripTags(row.detail)
          });
        });

        events.forEach(function (event, index) {
          lines.push("BEGIN:VEVENT");
          lines.push(
            "UID:askavet-" +
            index +
            "-" +
            dateStamp(event.d) +
            "@askavet.com"
          );
          lines.push(
            "DTSTAMP:" +
            utcTimestamp(new Date())
          );
          lines.push(
            "DTSTART;VALUE=DATE:" +
            dateStamp(event.d)
          );
          lines.push(
            "SUMMARY:" +
            icsEscape(event.t)
          );
          lines.push(
            "DESCRIPTION:" +
            icsEscape(
              event.desc +
              " — via ASK A VET Schedule Builder"
            )
          );
          lines.push("BEGIN:VALARM");
          lines.push("TRIGGER:-P2D");
          lines.push("ACTION:DISPLAY");
          lines.push(
            "DESCRIPTION:" +
            icsEscape(event.t)
          );
          lines.push("END:VALARM");
          lines.push("END:VEVENT");
        });

        lines.push("END:VCALENDAR");

        var blob = new Blob(
          [lines.join("\r\n")],
          {
            type: "text/calendar"
          }
        );

        var url =
          URL.createObjectURL(blob);

        var link =
          document.createElement("a");

        link.href = url;
        link.download =
          (
            plan.opt.name
              ? plan.opt.name.replace(/\s+/g, "-")
              : "pet"
          ) +
          "-askavet-schedule.ics";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 500);
      }

      function pad(number) {
        return number < 10
          ? "0" + number
          : String(number);
      }

      function dateStamp(date) {
        return (
          date.getFullYear() +
          pad(date.getMonth() + 1) +
          pad(date.getDate())
        );
      }

      function utcTimestamp(date) {
        return (
          date.getUTCFullYear() +
          pad(date.getUTCMonth() + 1) +
          pad(date.getUTCDate()) +
          "T" +
          pad(date.getUTCHours()) +
          pad(date.getUTCMinutes()) +
          pad(date.getUTCSeconds()) +
          "Z"
        );
      }

      function icsEscape(value) {
        return (value || "")
          .replace(/\\/g, "\\\\")
          .replace(/;/g, "\\;")
          .replace(/,/g, "\\,")
          .replace(/\n/g, "\\n");
      }

      function stripTags(value) {
        return (value || "")
          .replace(/<[^>]*>/g, "");
      }

      function esc(value) {
        return (value || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }
    }
  }

  if (
    !customElements.get(
      "s-vaccination-parasite-schedule-builder"
    )
  ) {
    customElements.define(
      "s-vaccination-parasite-schedule-builder",
      VaccinationParasiteScheduleBuilder
    );
  }
})();
